// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"19549f53","85":"73a3ac35","203":"57155c2d","278":"6110e349","378":"20947228","538":"75459e48","661":"481968bd","703":"4221e736","735":"f333e359","746":"92e8c909","793":"5b9d1687","985":"f39fe0b2"}[chunkId] + ".chunk.js";
};